module.exports = __webpack_public_path__ + "img/contact2.8d0d513.png";